const header = () => {
  menuMobile();
  initMenu();
  searchButton();
}

const menuMobile = () => {
  $(".navbar-toggle").click(function () {
    console.log("click")
    if ($(".menu-mobile").hasClass("show")) {
      //hide menu
      $(".menu-mobile").removeClass("show");

      //fix lỗi width của banner nên sẽ dùng cái này để ẩn nội dung trang khi show menu
      $("#app").css({
        height: "unset",
        overflow: "inital"
      })
    }
    else {
      $(".menu-mobile").addClass("show");
      setTimeout(() => {
        $("#app").css({
          height: 0,
          overflow: "hidden"
        })
      }, 300)
    }
    $(this).toggleClass("collapsed")
  });

  //click submenu
  $(".nav-item.has-sub-menu > .arrow").click(function () {
    const parent = $(this).parent(".nav-item");
    if (parent.hasClass("active")) {

      parent.find(".tt-arrow").removeClass("down");
      //phải đợi tất cả các element chạy xong mới thực hiện remove class
      let count = 0;
      const totalElement = parent.find(".sub-menu").length;

      parent.find(".sub-menu").slideUp(300, function () {
        count++;
        if (count >= totalElement) {
          parent.removeClass("active");
          parent.find(".nav-item").removeClass("active"); //xóa active của các sub-menu
        }
      });

    } else {
      //tìm ở level 1 nếu có thì mở
      $(this).find(".tt-arrow").addClass("down");
      if (parent.find(".sub-menu:not(.sub-menu .sub-menu)").length > 0) {
        parent.addClass("active").find(".sub-menu:not(.sub-menu .sub-menu)").stop(true, true).slideDown(300, () => {
        });
      }
      else {
        //nếu không thì mở level 2:
        parent.addClass("active").find(".sub-menu").stop(true, true).slideDown(300, () => {
        });
      }
    }
  })
}

const initMenu = () => {
  $(".dropdown-item.active").parents(".submenu.dropdown-menu").parent().find(" > .dropdown-item").addClass("active")
  $(".dropdown-item.active").parents(".dropdown").addClass("active")
}

const searchButton = () => {
  $(".search-btn").click(function () {
    $(".search-inp").toggleClass("active");
    $(".navbar-collapse.menu").toggleClass("onSearch")
  })
}

module.exports = header;
